import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

type Access = 'hidden' | 'read' | 'edit';
const labels: Record<Access, string> = { hidden: 'Oculto', read: 'Ver', edit: 'Preencher' };
const allOptions: readonly Access[] = ['hidden', 'read', 'edit'];
const fillOptions: readonly Access[] = ['hidden', 'edit'];

export function ChecklistFieldAccess({ name, group, required, value, onChange, disabled, allowRead = true }: {
  name: string;
  group?: string | null;
  required?: boolean;
  value: Access;
  onChange: (value: Access) => void;
  disabled?: boolean;
  allowRead?: boolean;
}) {
  return <View style={styles.field}>
    {!!group && <Text style={styles.group}>{group}</Text>}
    <Text style={styles.name}>{name}{required ? ' *' : ''}</Text>
    <View style={styles.choices}>
      {(allowRead ? allOptions : fillOptions).map(option => {
        const selected = value === option;
        return <TouchableOpacity key={option} accessibilityRole="radio"
          accessibilityLabel={`${name}: ${labels[option]}`}
          accessibilityState={{ checked: selected, disabled }}
          disabled={disabled} onPress={() => onChange(option)}
          style={[styles.choice, selected && styles.selected, disabled && styles.disabled]}>
          <Text style={[styles.label, selected && styles.selectedLabel]}>{labels[option]}</Text>
        </TouchableOpacity>;
      })}
    </View>
  </View>;
}

const styles = StyleSheet.create({
  field: { paddingVertical: 12, borderBottomWidth: 1, borderBottomColor: '#e2e8f0', gap: 5 },
  group: { fontSize: 11, color: '#64748b' },
  name: { fontSize: 14, fontWeight: '600', color: '#334155' },
  choices: { flexDirection: 'row', gap: 6, paddingTop: 3 },
  choice: { flex: 1, minHeight: 40, justifyContent: 'center', alignItems: 'center', paddingVertical: 9, paddingHorizontal: 8, borderRadius: 8, backgroundColor: '#f1f5f9' },
  selected: { backgroundColor: '#176b96' },
  label: { fontSize: 13, color: '#334155' },
  selectedLabel: { color: '#fff', fontWeight: '600' },
  disabled: { opacity: 0.5 },
});
